import React from 'react';
import { authRoles } from '../../utils/auth/authRoles';

const delayRoutes = [
	{
		path: '/lead/delays',
		component: React.lazy(() => import('./index')),
		auth: authRoles.level3,
	},
];

export default delayRoutes;
